import React, { useState } from "react";
import "./Css/StudentManagment.css";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const students = [
  {
    id: "STD465456",
    name: "आर्य पाटील",
    exam: "पूर्व उ. मा. शिष्यवृत्ती परीक्षा",
    subject: "मराठी",
    class: "५ वी",
    email: "aryan.patil@gmail.com",
    teacher: "सौ. प्रिय संध्या",
  },
  {
    id: "STD548456",
    name: "संकट पाटील",
    exam: "ज. नवोदय विद्यालय प्रवेश परीक्षा",
    subject: "गणित",
    class: "६ वी",
    email: "sanket@gmail.com",
    teacher: "श्री. अमित पाटील",
  },
  {
    id: "STD122589",
    name: "अजय शिंदे",
    exam: "NMMS Exam",
    subject: "बुद्धिमत्ता",
    class: "८ वी",
    email: "amey.shende@gmail.com",
    teacher: "सौ. मृण पाटील",
  },
  {
    id: "STD465456",
    name: "आर्य पाटील",
    exam: "पूर्व उ. मा. शिष्यवृत्ती परीक्षा",
    subject: "मराठी",
    class: "५ वी",
    email: "aryan.patil@gmail.com",
    teacher: "सौ. प्रिय संध्या",
  },
  {
    id: "STD548456",
    name: "संकट पाटील",
    exam: "ज. नवोदय विद्यालय प्रवेश परीक्षा",
    subject: "गणित",
    class: "६ वी",
    email: "sanket@gmail.com",
    teacher: "श्री. अमित पाटील",
  },
  {
    id: "STD122589",
    name: "अजय शिंदे",
    exam: "NMMS Exam",
    subject: "बुद्धिमत्ता",
    class: "८ वी",
    email: "amey.shende@gmail.com",
    teacher: "सौ. मृण पाटील",
  },
];

const StudentTable = () => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [totalPages, setTotalPages] = useState(1);


  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const filteredData = questions;
  const sortedData = questions;
  const [counts, setCounts] = useState({
    totalStudents: 0,
    activeStudents: 0,
    inactiveStudents: 0
  });

  const API = `${API_BASE}/api`;

  const fetchCounts = async () => {
    try {
      const res = await axios.get(`${API}/instituteadmin/students/dashboard-counts`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
      setCounts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchStudents = async (page = 1, size = rowsPerPage) => {
    try {
      const res = await axios.get(`${API}/instituteadmin/students`, {
        params: {
          PageNumber: page,
          PageSize: size,
          Search: searchQuery
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

      const mapped = res.data.data.map(s => ({
        id: s.id,                         
        uniqueId: s.studentUniqueId,      
        name: s.studentName,
        email: s.email,
        class: s.standardName,
        teacher: "-",
        exam: "-",
        subject: s.softwares?.map(x => x.softwareName).join(", ")
      }));

      setQuestions(mapped);
      console.log(res.data, 'students')
      setCurrentPage(res.data.pageNumber);
      setRowsPerPage(res.data.pageSize);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  useEffect(() => {
    fetchStudents(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage, searchQuery]);

  const handleViewClick = (index) => {
    navigate("/dashboard/studentview");
    // OR with id → `/dashboard/studentview/${students[index].id}`
  };

  const handleEditClick = (index) => {
    navigate("/dashboard/studentedit");
  };
  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    const student = questions[deleteIndex];

    try {
      await axios.delete(`${API}/instituteadmin/${student.id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

      fetchStudents(currentPage, rowsPerPage);
    } catch (err) {
      console.error(err);
    }

    setShowDeletePopup(false);
  };

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };;
  const handlePaginationClick = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="student-wrapper">
      <div className="notification-header">
        <h2>विद्यार्थी व्यवस्थापन</h2>
        <button
          className="stu-btn"
          onClick={() => navigate("/dashboard/studentform")}
        >
          नवीन विद्यार्थी जोडा
        </button>
      </div>
      {/* Top Filters */}
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>

        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9.3845 8.3845V7.3845H17.6155V8.3845H9.3845ZM9.3845 11.1538V10.1538H17.6155V11.1538H9.3845ZM14.2308 21V18.7905L19.5635 13.4827C19.6622 13.3968 19.7647 13.3333 19.8712 13.2923C19.9776 13.2513 20.084 13.2308 20.1905 13.2308C20.3007 13.2308 20.4122 13.2522 20.525 13.2952C20.6378 13.3381 20.7372 13.4025 20.823 13.4885L21.748 14.4327C21.8302 14.5314 21.8927 14.634 21.9355 14.7405C21.9785 14.8468 22 14.9532 22 15.0595C22 15.166 21.9827 15.2734 21.948 15.3818C21.9135 15.4901 21.8468 15.5936 21.748 15.6923L16.4405 21H14.2308ZM20.1905 16.0155L21.1155 15.0595L20.1905 14.1155L19.2405 15.0655L20.1905 16.0155ZM6 21C5.43583 21 4.9615 20.8077 4.577 20.423C4.19233 20.0385 4 19.5642 4 19V16.2308H7V3H20V10.8712C19.8205 10.8762 19.6497 10.8952 19.4875 10.928C19.3253 10.9607 19.1628 11.0071 19 11.0673V4H8V16.2308H13.3462L11.8463 17.7308V21H6Z" fill="#616161" />
          </svg>परीक्षेचे नाव</option>
          <option>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा </option>
          <option>ज. नवोदय विद्यालय प्रवेश परीक्षा</option>
          <option>NMMS Exam</option>
        </select>

        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5 18.2271V16.9964H13V17.9964L5 18.2271ZM5 14.4386V13.4386H19V14.4386H5ZM5 10.5541V9.55412H19V10.5541H5ZM5 6.99637V5.76562H19V6.99637H5Z" fill="#616161" />
          </svg>विषय</option>
          <option>मराठी</option>
          <option>English</option>
        </select>

        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12.0011 18.6947L6.00113 15.4332V10.587L3.07812 9.0025L12.0011 4.15625L20.9241 9.0025V15.3872H19.9241V9.564L18.0011 10.587V15.4332L12.0011 18.6947ZM12.0011 12.7025L18.8319 9.0025L12.0011 5.3025L5.17038 9.0025L12.0011 12.7025ZM12.0011 17.5545L17.0011 14.8545V11.137L12.0011 13.845L7.00113 11.137V14.8545L12.0011 17.5545Z" fill="#616161" />
          </svg>इयत्ता</option>
          <option>५ वी</option>
          <option>६ वी</option>
          <option>७ वी</option>
        </select>
      </div>

      {/* Card */}
      <div className="summary-card">
        <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M7.6925 35C6.92528 35 6.28472 34.7431 5.77083 34.2292C5.25694 33.7153 5 33.0747 5 32.3075V26.6667H6.66667V32.3075C6.66667 32.5642 6.77347 32.7993 6.98708 33.0129C7.20069 33.2265 7.43583 33.3333 7.6925 33.3333H13.3333V35H7.6925ZM5 13.3333V7.6925C5 6.92528 5.25694 6.28472 5.77083 5.77083C6.28472 5.25694 6.92528 5 7.6925 5H13.3333V6.66667H7.6925C7.43583 6.66667 7.20069 6.77347 6.98708 6.98708C6.77347 7.20069 6.66667 7.43583 6.66667 7.6925V13.3333H5ZM18.0129 30.6025C15.8204 30.1922 13.939 29.2018 12.3688 27.6313C10.7982 26.061 9.80778 24.1796 9.3975 21.9871H11.0642C11.4403 23.7329 12.256 25.2335 13.5112 26.4888C14.7665 27.744 16.2671 28.5597 18.0129 28.9358V30.6025ZM9.3975 18.0129C9.80778 15.8204 10.7982 13.9374 12.3688 12.3637C13.939 10.7901 15.8204 9.80139 18.0129 9.3975V11.0642C16.2671 11.4403 14.7665 12.256 13.5112 13.5113C12.256 14.7665 11.4403 16.2671 11.0642 18.0129H9.3975ZM20 22.5C19.2969 22.5 18.7046 22.259 18.2229 21.7771C17.741 21.2954 17.5 20.7031 17.5 20C17.5 19.2906 17.741 18.6965 18.2229 18.2179C18.7046 17.7393 19.2969 17.5 20 17.5C20.7094 17.5 21.3035 17.7393 21.7821 18.2179C22.2607 18.6965 22.5 19.2906 22.5 20C22.5 20.7031 22.2607 21.2954 21.7821 21.7771C21.3035 22.259 20.7094 22.5 20 22.5ZM21.9871 30.6025V28.9358C23.7329 28.5597 25.2335 27.744 26.4888 26.4888C27.744 25.2335 28.5597 23.7329 28.9358 21.9871H30.6025C30.1986 24.1796 29.2099 26.061 27.6363 27.6313C26.0626 29.2018 24.1796 30.1922 21.9871 30.6025ZM28.9358 18.0129C28.5597 16.2671 27.744 14.7665 26.4888 13.5113C25.2335 12.256 23.7329 11.4403 21.9871 11.0642V9.3975C24.1796 9.80778 26.0626 10.7982 27.6363 12.3687C29.2099 13.939 30.1986 15.8204 30.6025 18.0129H28.9358ZM26.6667 35V33.3333H32.3075C32.5642 33.3333 32.7993 33.2265 33.0129 33.0129C33.2265 32.7993 33.3333 32.5642 33.3333 32.3075V26.6667H35V32.3075C35 33.0747 34.7431 33.7153 34.2292 34.2292C33.7153 34.7431 33.0747 35 32.3075 35H26.6667ZM33.3333 13.3333V7.6925C33.3333 7.43583 33.2265 7.20069 33.0129 6.98708C32.7993 6.77347 32.5642 6.66667 32.3075 6.66667H26.6667V5H32.3075C33.0747 5 33.7153 5.25694 34.2292 5.77083C34.7431 6.28472 35 6.92528 35 7.6925V13.3333H33.3333Z" fill="#499999" />
        </svg></div>
        <div>
          <h4>एकूण विद्यार्थी</h4>
          <p>{counts.totalStudents}</p>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        <table>

          <thead>
            <tr>
              <th>क्र.</th>
              <th>विद्यार्थी ID</th>
              <th>विद्यार्थी नाव</th>
              <th>परीक्षेचे नाव</th>
              <th>विषय</th>
              <th>इयत्ता</th>
              <th>ईमेल</th>
              <th>नियुक्त शिक्षक</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((stu, index) => (
                <tr key={`${stu.id}-${index}`}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{stu.uniqueId}</td>
                  <td>{stu.name}</td>
                  <td>{stu.exam}</td>
                  <td>{stu.subject}</td>
                  <td>{stu.class}</td>
                  <td>{stu.email}</td>
                  <td>{stu.teacher}</td>
                  <td className="actions">
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(`/dashboard/studentview/${stu.id}`)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(`/dashboard/studentedit/${stu.id}`)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(index)} width="12" height="14" viewBox="0 0 14 16" fill="none">
                      <path d="M2.6155 15.7693C2.15517 15.7693 1.77083 15.6151 1.4625 15.3068C1.15417 14.9984 1 14.6141 1 14.1538V1.76925H0V0.769251H4V0H10V0.769251H14V1.76925H13V14.1538C13 14.6141 12.8458 14.9984 12.5375 15.3068C12.2292 15.6151 11.8448 15.7693 11.3845 15.7693H2.6155ZM4.80775 12.7693H5.80775V3.76925H4.80775V12.7693ZM8.19225 12.7693H9.19225V3.76925H8.19225V12.7693Z" fill="#FF1501" />
                    </svg>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box delete-confirm-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
                <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000" />
              </svg>
              <h3>विद्यार्थी हटवा</h3>
              <p>तुम्हाला हा विद्यार्थी कायमचा हटवायचा आहे का?</p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button className="delete-confirm-btn" onClick={confirmDelete}>होय </button>
            </div>
          </div>
        </div>
      )}

      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentTable;
